import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  type: ToastType;
  title: string;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  toasts = signal<ToastMessage[]>([]);

  success(title: string, message?: string, autoCloseMs: number = 4000): number {
    return this.show('success', title, message, autoCloseMs);
  }

  error(title: string, message?: string, autoCloseMs: number = 5000): number {
    return this.show('error', title, message, autoCloseMs);
  }

  info(title: string, message?: string, autoCloseMs: number = 4000): number {
    return this.show('info', title, message, autoCloseMs);
  }

  dismiss(id: number): void {
    this.toasts.update((arr) => arr.filter((t) => t.id !== id));
  }

  private show(type: ToastType, title: string, message: string | undefined, autoCloseMs: number): number {
    const id = this.nextId++;
    this.toasts.update((arr) => [...arr, { id, type, title, message }]);
    if (autoCloseMs > 0) {
      setTimeout(() => this.dismiss(id), autoCloseMs);
    }
    return id;
  }
}
